<template>
  <div class="top-ten-stat-card-container">
    <div class="stat-card-header">
      <div class="title">
        {{ $t('stats_top_guests.title') }}
      </div>
      <DashboardButton variant="black" @click="$router.push('/clients_base')"
        >
        {{ $t('stats_top_guests.btn_all') }}</DashboardButton
      >
    </div>
    <div class="list-container">
      <div class="list">
        <div class="list-header">
          <div>
            {{ $t('stats_top_guests.col_name') }}
          </div>
          <div>
            {{ $t('stats_top_guests.col_orders') }}
          </div>
        </div>
        <div v-for="entry in firstColumn" :key="entry.client" class="list-row">
          <div>{{ entry.client }}</div>
          <div>{{entry.count}}</div>
        </div>
      </div>
      <div class="list" v-if="secondColumn && secondColumn.length">
        <div class="list-header">
          <div>
            {{ $t('stats_top_guests.col_name') }}
          </div>
          <div>
            {{ $t('stats_top_guests.col_orders') }}
          </div>
        </div>
        <div v-for="entry in secondColumn" :key="entry.client" class="list-row">
          <div>{{ entry.client }}</div>
          <div>{{entry.count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    DashboardButton,
  },
  props: {
    top: Array
  },
  computed: {
    firstColumn() {
      return this.top.slice(0,);
    },
    secondColumn() {
      return this.top.slice(5);
    }
  }
};
</script>
<style scoped>
.top-ten-stat-card-container {
  width: 100%;
  background: #e5e5e5;
  border-radius: 1.3333333333333333vh;
  padding: 2.222vh;
  margin-top: 3.3333vh;
  box-sizing: border-box;
}
.stat-card-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
}
.list-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.list {
  width: calc(50% - 1.1111vh);
}
.list-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.1111vh;
  font-size: 2.222vh;
  line-height: 2.5555vh;
  color: #908f8d;
}
.list-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 2.222vh;
  line-height: 2.5555vh;
  color: #1d1d1b;
  padding: 0.555vh;
  border-bottom: 0.111vh solid #908f8d;
}
.list-row:hover {
  color: #ededed;
  background: #129b81;
}
.list-row:last-child {
  border: none;
}
</style>
